<template>
  <div>
    <resize-observer @notify="__resizeHanlder" />
    <el-drawer
      :title="title"
      v-bind="$attrs"
      :visible="drawer"
      :append-to-body="true"
      v-on:update:visible="$emit('update:drawer', $event)"
      @open="$emit('open', $event)"
      @close="$emit('close', $event)"
    >
      <el-container
        class="scrollable"
        :style="{ maxHeight: `${drawerHeight - 100}px` }"
      >
        <el-main>
          <slot></slot>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
import throttle from "lodash/throttle";

export default {
  name: "RabbeyBaseDrawer",
  events: ["close"],
  inheritAttrs: false,
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: null
    }
  },
  created() {
    this.drawerHeight = window.innerHeight;
  },
  data() {
    return {
      drawerHeight: 0
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    __resizeHanlder: throttle(function (_e) {
      this.drawerHeight = window.innerHeight;
    }, 700)
    /*
    ,close() {
      this.$store.dispatch("navixy/set_total_gps_by_user_to_default");
    }
    */
  }
};
</script>
